import { createTableColumn, TableColumnDefinition } from '@fluentui/react-components';
import { Asset } from '../utils/types';

const performanceOrder = ['Best', 'Good', 'Low', 'Learning', 'Unrated'];
const policyStatusOrder = ['Approved', 'ApprovedLimited', 'Rejected', 'Pending'];

export const columns: TableColumnDefinition<Asset>[] = [
  createTableColumn<Asset>({
    columnId: 'performance',
    compare: (a, b) => performanceOrder.indexOf(b.PerformanceLabel ?? '') - performanceOrder.indexOf(a.PerformanceLabel ?? ''),
  }),
  createTableColumn<Asset>({
    columnId: 'policy-status',
    compare: (a, b) => policyStatusOrder.indexOf(b.EditorialStatus) - policyStatusOrder.indexOf(a.EditorialStatus),
  }),
];

export const columnsWithConversions: TableColumnDefinition<Asset>[] = [
  createTableColumn<Asset>({
    columnId: 'conversions',
    compare: (a, b) => (b.PerformanceMetrics.ConversionsCredit || 0) - (a.PerformanceMetrics.ConversionsCredit || 0),
  }),
  createTableColumn<Asset>({
    columnId: 'policy-status',
    compare: (a, b) => policyStatusOrder.indexOf(b.EditorialStatus) - policyStatusOrder.indexOf(a.EditorialStatus),
  }),
];
